import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'
import { useParams } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'
//import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'

const AdminDivisionList = () => {
	console.log('inside AdminDivisionList')

	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [divisionId, setDivisionId] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()
	const [playerStats, setPlayerStats] = useState()
	const [isCurrent, setIsCurrent] = useState()
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [gamesExistModal, setGamesExistModal] = useState(false)
	const [allGamesArray, setAllGamesArray] = useState([])
	const [divisionDeleted, setDivisionDeleted] = useState()
	const [divisionToDelete, setDivisionToDelete] = useState()
	const leagueName = useParams().leagueName
	//const divisionName = useParams().divisionName
	//const session = useParams().session
	const year = useParams().year

	//First, lets tap into getDivisionsInLeague the backend to get all divisions in this tournament:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setDivisionDeleted(false)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueName}/${year}/divisions`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedDivisions(responseData.listOfDivisions)
				setIsCurrent(responseData.isCurrent)
				setPlayerStats(responseData.playerStats)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueName, setLoadedDivisions, year, divisionDeleted])

	const errorHandler = () => {
		setError(null)
	}

	const showDeleteWarningHandler = async (e, divisionname) => {
		console.log('e: ' + e.target.id)
		const value = e.target.id
		setDivisionToDelete(divisionname)
		setDivisionId(loadedDivisions[value]._id)
		console.log('fucking divisionId: ' + loadedDivisions[value]._id)
		const divisionId = loadedDivisions[value]._id
		//First, we need to go out and see if this division has any games scheduled
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${divisionId}/doesDivisionHaveGames`,
			)

			const responseData = await response.json()
			console.log('responseData: ' + JSON.stringify(responseData))
			console.log('responseData LENGTH: ' + responseData.allGamesArray.length)
			if (!response.ok) {
				throw new Error(responseData.message)
			}
			if (responseData.allGamesArray.length === 0) {
				console.log('looks like theres no games')
				setShowConfirmModal(true)
			} else {
				console.log('we DO have games')
				setGamesExistModal(true)
			}
			setIsLoading(false)
		} catch (err) {
			setError(err.message)
		}
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
		setGamesExistModal(false)
	}

	//console.log('team right here: ' + teamId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		console.log('divisionId: ' + divisionId)
		//
		//
		//
		//
		if (allGamesArray.length > 0) {
			console.log('this division has games.  they must be deleted first')
		}
		//
		//
		if (allGamesArray.length === 0) {
			try {
				await sendRequest(
					process.env.REACT_APP_BACKEND_URL +
						`/admin/${divisionId}/removeDivision`,
					'DELETE',
				)
			} catch (err) {}
			setDivisionDeleted(true)
			console.log('DELETING...')
		}
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete <h1>{divisionToDelete}</h1>
						</p>
						<p className='modalText'>
							This will also delete all the teams and rostered players from the
							division.
						</p>
						<br></br>
						<button
							class='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE DIVISION
						</button>
					</React.Fragment>
				}
			></Modal>
			<Modal
				show={gamesExistModal}
				onCancel={cancelDeleteHandler}
				header='WE HAVE GAMES FOR THIS DIVISION!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							It looks like there are games scheduled for{' '}
							<h1>{divisionToDelete}</h1>
						</p>
						<p className='modalText' style={{ color: 'red' }}>
							Delete this divisions games, then come back and delete the
							division.
						</p>
						<br></br>
						<button
							class='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							OK
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedDivisions && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>{leagueName} - Divisions</h1>
					<h2>{year}</h2>
					<table id='teams' className='divisionTable'>
						<thead>
							<tr>
								<th>Division Name</th>
								<th>Teams</th>
								<th></th>
								{isCurrent && <th style={{ width: '25%' }}></th>}
								{isCurrent && <th></th>}
							</tr>
						</thead>
						<tbody>
							{loadedDivisions.map((division, key) => {
								return (
									<tr key={key}>
										<td>{division.divisionName}</td>
										<td>{division.assignedTeams}</td>
										<td>
											<NavLink
												className='navlinks'
												to={
													playerStats === true
														? // goes to AdminTeamList_PlayerStats
															`/admin/${leagueName}/${year}/${division._id}/${division.divisionName}/teams-player-stats`
														: `/admin/${leagueName}/${year}/${division._id}/teams` // goes to AdminTeamList
												}
											>
												Teams
											</NavLink>
										</td>
										{isCurrent && (
											<td>
												<NavLink
													className='navlinks'
													to={`/admin/${leagueName}/${year}/updateDivision/${division._id}`}
													exact
												>
													Edit Division
												</NavLink>
											</td>
										)}
										{isCurrent && (
											<td>
												<button
													className='buttonButton'
													style={{ color: 'red' }}
													id={key}
													onClick={(e) =>
														showDeleteWarningHandler(e, division.divisionName)
													}
												>
													DELETE
												</button>
											</td>
										)}
									</tr>
								)
							})}
						</tbody>
						{isCurrent && (
							<AdminButton
								className='add'
								style={{ width: '150%' }}
								to={`/admin/${leagueName}/${year}/newDivision`}
								exact
							>
								Add Division(s)
							</AdminButton>
						)}
					</table>
				</div>
			)}
			{!isLoading && !loadedDivisions && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>{leagueName} - Divisions</h1>
					<h2>{year}</h2>
					<table id='teams' className='divisionTable'>
						<thead>
							<tr>
								<th>Division Name</th>
								<th>Teams</th>
								<th></th>
								{isCurrent && <th></th>}
								{isCurrent && <th></th>}
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>NO DIVISIONS IN THIS TOURNAMENT YET</td>
							</tr>
						</tbody>
						{isCurrent && (
							<AdminButton
								className='add'
								style={{ width: '150%' }}
								//to={`/admin/${leagueName}/${session}/${year}/newTeam`}
								to={`/admin/${leagueName}/${year}/newDivision`}
								exact
							>
								Add Division(s)
							</AdminButton>
						)}
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminDivisionList
